export default __webpack_public_path__ + "static/media/Screenshot (139).83c7a8ae.png";